export default function StatCard({ label, value, sub, tone = "neutral", testid, delta, icon: Icon }) {
  const tones = {
    neutral: "text-[var(--text-primary)]",
    profit:  "txt-profit",
    loss:    "txt-loss",
    warn:    "txt-warn",
  };
  return (
    <div data-testid={testid} className="panel panel-hover p-4 sm:p-5 flex flex-col gap-3 min-h-[100px] min-w-0">
      <div className="flex items-start justify-between gap-2 min-w-0">
        <div className="text-[10px] text-[var(--text-muted)] tracking-[0.14em] uppercase font-section leading-none min-w-0 [overflow-wrap:anywhere]">{label}</div>
        {Icon && <Icon className="w-4 h-4 shrink-0 text-[var(--text-muted)]" strokeWidth={1.5} />}
      </div>
      {/* RU-UIMOBILE UM-10: smaller on phones, unchanged from sm; wraps instead of crossing the border. */}
      <div data-kpi-value className={`kpi-num text-2xl sm:text-[36px] leading-none min-w-0 [overflow-wrap:anywhere] ${tones[tone]}`}>{value}</div>
      {(sub || delta != null) && (
        <div className="flex items-center gap-2 mt-auto min-w-0">
          {sub && <div className="text-[11px] text-[var(--text-muted)] font-mono-data leading-tight min-w-0 [overflow-wrap:anywhere]">{sub}</div>}
          {delta != null && (
            <span className={`text-[10px] font-mono-data font-semibold ml-auto ${delta >= 0 ? "txt-profit" : "txt-loss"}`}>
              {delta >= 0 ? "+" : ""}{delta}%
            </span>
          )}
        </div>
      )}
    </div>
  );
}
